import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: 500,
    height: 250,
    paddingTop: '5%'
  },
  title: {
    paddingBottom: '2%'
  },
  upload: {
    width: 50,
    alignItems: 'flex-end',
    background: '#008f7a',
    '&:hover': {
      backgroundColor: '#008f7a'
    }
  },
  selectFile: {
    width: 150,
    textTransform: 'none',
    background: '#ECECEC',
    color: '#263057'
  },
  fileName: {
    marginLeft: '2%'
  },
  input: {
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    color: '#2C3532',
    cursor: 'pointer',
    '&:hover': {
      color: '#008f7a',
      backgroundColor: '#E1E1E1'
    }
  },
  iconInput: {
    fontSize: 32
  },
  text: {
    fontSize: '0.9em',
    fontWeight: 'bold',
    paddingLeft: 10,
    textOverflow: 'ellipsis',
    width: '78%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  linkButton: {
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bolder',
    textDecoration: 'underline',
    fontSize: '1em',
    backgroundColor: 'transparent',
    margin: 0,
    fontFamily: 'Roboto',
    color: '#EFBA1B'
  }
}))

export default useStyles
